export enum TripStatus {
    Started = "Started",
    Ready = "Ready",
    Waiting = "Waiting",
    Importing = "Importing",
    Complete = "Complete"
}